<template>

  <div class="fillit" v-show="kpi">
      <table class="kpitable">
        <tr>
          <td class="kpicol-small"
              v-bind:style="{ width: getMinorItemWidth(minorWaveCount) + '%' }"
              v-for="index in minorWaveCount"
              v-bind:class="getBackgroundClass(index)"
              v-bind:key="index">
            <div class="container3">
              <div class="head-text narrow">{{ getSlotName(index) }}</div>
              <div class="small-text">{{ getSlotValue(index) }}</div>
            </div>
          </td>

          <td class="kpicol-small"
          v-bind:style="{ width: getMinorItemWidth(minorWaveCount) + '%' }"
              v-bind:class="getBackgroundClass(waveCount)">
            <div class="container2">
              <div class="head-text left narrow">{{ getSlotName(waveCount) }}</div>
              <div class="small-text">{{ getSlotValue(waveCount) }}</div>
            </div>
          </td>
        </tr>
      </table>
  </div>

</template>

<script>

  export default {

    name: 'CompareItem',

    data () {
      return {
      }
    },

    props:[
      'monochrome',
      'kpi',
      'isCompetitionOverall'
    ],

    methods:{

      getBackgroundForIndicator: function (index) {
        if (this.monochrome) {
          return {'bc-gray' : true}
        }

        if (index === null) {
          return  {'bc-red' : true}
        }

        if (this.kpi === null || this.kpi.Competition === null ) {
          return {'bc-gray' : true}
        }

        if (this.kpi.Competition[index].Points === undefined) {
          return {'bc-gray' : true}
        }
        if (this.kpi.Competition[index].Points < 80) {
          return { 'bc-red': true }
        }
        else if (this.kpi.Competition[index].Points < 90) {
          return  {'bc-yellow' : true}
        }
        else {
          return  {'bc-green' : true}
        }
      },

      getBackgroundClass: function (slot){
        var _kpi = this.kpi
        if (this.isCompetitionOverall) {
          if (!_kpi || !_kpi.SurveyWave || this.monochrome) return { 'bc-gray' : true }
        } else {
          if (!_kpi || !_kpi.Competition || this.monochrome) return { 'bc-gray' : true }
        }
        // HACK: Fix Enquiry Reference fast
        if (this.kpi.KpiCode === 'Enquiry Reference') {
          if (slot === 101) {
            return this.getBackgroundForIndicator(0)
          }
         return {'bc-gray' : true}
        }

        let it = this.getSlot(slot)
        if (this.isCompetitionOverall) {
          if (!it || it.Result === undefined) return {'bc-gray' : true}
          if (it.PropertyValue == 'Competitors') return {'bc-gray' : true}

          if (it.Result < 80) return { 'bc-red': true }
          else if (it.Result < 90) return  {'bc-yellow' : true}
          else return {'bc-green' : true}
        } else {
          if (!it || it.Points === undefined) return {'bc-gray' : true}
          if (it.Brand == 'Competitors') return {'bc-gray' : true}

          if (it.Points < 80) return { 'bc-red': true }
          else if (it.Points < 90) return  {'bc-yellow' : true}
          else return {'bc-green' : true}
        }


      },

      getSlot: function(slot) {
        if (this.isCompetitionOverall) {
          if (!this.kpi || !this.kpi.SurveyWave)
            return undefined

          // HACK: Fixes sorting (static)
          if (slot === 1) return this.kpi.SurveyWave[2]
          if (slot === 2) return this.kpi.SurveyWave[3]
          if (slot === 3) return this.kpi.SurveyWave[0]
          if (slot === 4) return this.kpi.SurveyWave[1]
          if (slot === 5) return this.kpi.SurveyWave[4]

          return this.kpi.SurveyWave[slot - 1]
        }
        if (!this.kpi || !this.kpi.Competition)
          return undefined
        return this.kpi.Competition[slot - 1]
      },

      getSlotName: function(slot) {
        let it = this.getSlot(slot)
        if (this.isCompetitionOverall) {
          if (it === undefined || it.PropertyValue === undefined) return ''
          return it.PropertyValue
        }
        if (it === undefined || it.Brand === undefined) return ''
        return it.Brand
      },

      getSlotValue: function(slot) {
        let it = this.getSlot(slot)
        if (this.isCompetitionOverall) {
          if (it === undefined || it.Result === undefined) return ''
          return it.Result
        }
        if (it === undefined || it.Points === undefined) return ''
        return it.Points
      },

      hasWaves(context) {
        if (this.isCompetitionOverall) {
          return context.kpi && context.kpi.SurveyWave && _.size(context.kpi.SurveyWave) > 0
        }
        return context.kpi && context.kpi.Competition && _.size(context.kpi.Competition) > 0
      },

      getMinorItemWidth(waves) {
        if (waves < 4) return 16.666
        return 80 / waves
      }
    },

    computed: {
      waveCount: function () {
        if (!this.hasWaves(this)) return 4
        if (this.isCompetitionOverall) {
          return Math.max(4, _.size(this.kpi.SurveyWave))
        }
        return Math.max(4, _.size(this.kpi.Competition))
      },

      minorWaveCount: function () {
        return this.waveCount - 1
      },

    }
  }

</script>


<style scoped>

   .narrow {
    letter-spacing: -0.15em;
    /* width: 160px; */
    text-overflow: ellipsis;
  }

  .black{
    color: black;
  }
  .left{
    text-align:left;
  }
  .w50{
    width: 50.0%
  }
  .w16{
    width: 16.666%
  }

  .container3{
    margin: 0px;
    padding: 0px;
    display: inline-block;
    vertical-align: top;
    text-overflow: ellipsis;
    height: 32px;
    width: 100%;
    text-align: center;
  }

  .image {
    position: relative;
    top: -30px;
    right: -36px;
    border: 0px;
    color: black;
  }

  .head-text {
    position: relative;
    font-size: 9pt;
    font-stretch: ultra-condensed;
    font-weight: bold;
    top: 0px;
    width: 100%;
    display: block;
    text-align: center;
  }

  .small-text {
    position: relative;
    font-size: 9pt;
    display: block;
    text-align: center;
    top: -2px;
  }

  .container2 {
    display: flex;
    margin: 0px;
    padding: 0px;
    display: inline-block;
    *display: inline;
    vertical-align: top;
    height: 32px;
    width: 100%;
  }

  .block {
    display: inline-block;
    *display: inline;
    vertical-align: top;
  }

  .bc-highlight {
    position: relative;
    top: -6px;
    margin-top: -6px;
    padding: 0px;
    top: 0%;
    font-stretch: extra-condensed;
    font-weight: bold;
    width: 100%;
  }

  quartal {
    font-weight: 800;
    font-stretch: ultra-condensed;
    font-size: 9pt;
    position: absolute;
    left: 0px;
    top: 0px;
  }

  .bc-cell {
    float: left;
    text-overflow: ellipsis;
    margin: 0;
    padding: 0;
    display: table-cell;
  }

  .kpicol-small{
    width: 16.666%;
  }

  .kpicol-large {
    width: 50%;
  }

  .fillit{
    width: 100%;
    overflow: hidden;
  }

  .kpitable{
    height: auto;
    width:100%;
  }

  .bc-card {
    shape-margin: 0pt;
    padding: 0pt;
    margin: 0pt;
  }

  .card-body {
    padding: 0pt;
  }

  .bc-header {
    padding: 0pt;
    margin: 0pt;
    align-self: auto;
  }

  .card-header {
    padding: 0pt;
    margin: 0pt;
    align-self: auto;
  }

  .table {
    padding: 0pt;
    margin: 0pt;
  }

  .package-table {
    padding: 0pt;
    margin: 0pt;
  }

</style>
